import { z } from 'zod';
import { permissionKeys } from './permissions.ts';

export const loginRequestSchema = z.object({
  email: z.string().trim().toLowerCase().email().max(254),
  password: z.string().min(1).max(256),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const sessionUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  roleKey: z.string(),
  roleName: z.string(),
  permissions: z.array(z.enum(permissionKeys)),
  mfaEnabled: z.boolean().default(false),
});
export type SessionUser = z.infer<typeof sessionUserSchema>;
